import { Sparkles } from 'lucide-react';
import { Badge } from '@/shared/ui/badge';
import { Tooltip } from '@/shared/ui/tooltip';
import { formatTokens, formatUsd } from '@/features/ai-credits/model/format';
import type { SegmentationAiUsage } from '@/shared/types/segmentation';

/**
 * Custo de IA da segmentação. O legado só manda `aiUsage` para o master,
 * então para os demais usuários o badge simplesmente não aparece.
 */
export function SegmentationAiCostBadge({ usage }: { usage?: SegmentationAiUsage }) {
  if (!usage || usage.calls <= 0) return null;
  return (
    <Tooltip
      content={
        <span className="tabular-nums">
          {formatTokens(usage.inputTokens)} tokens de entrada · {formatTokens(usage.outputTokens)} de saída
          <br />
          {usage.calls} {usage.calls === 1 ? 'chamada' : 'chamadas'} ao modelo
        </span>
      }
    >
      <Badge variant="accent" className="shrink-0 tabular-nums">
        <Sparkles className="size-3" />
        {formatUsd(usage.costUsd)}
      </Badge>
    </Tooltip>
  );
}
